import { render } from "./TimeSetting.vue?vue&type=template&id=3d2baa3d"
import script from "./TimeSetting.vue?vue&type=script&lang=js"
export * from "./TimeSetting.vue?vue&type=script&lang=js"

import exportComponent from "D:\\Programming\\dashboard\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__